import React from 'react';
import { WHY_CHOOSE_US_POINTS } from '../constants';
import RevealOnScroll from './RevealOnScroll';

const WhyChooseUs: React.FC = () => {
  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-16 items-center">

          <RevealOnScroll>
            <div className="relative">
              <div className="absolute inset-0 bg-brand-600 transform rotate-3 rounded-3xl opacity-10"></div>
              <img
                src="https://otl.nyc3.cdn.digitaloceanspaces.com/otlexp.com%20-%20FE/Start%20Shipping%20Now.jpg"
                alt="Warehouse worker"
                className="relative rounded-3xl shadow-2xl w-full object-cover h-64 sm:h-96 md:h-[500px]"
              />
              <div className="absolute bottom-4 left-4 md:bottom-8 md:left-8 bg-white/90 backdrop-blur-sm p-4 md:p-6 rounded-2xl shadow-xl max-w-[200px] md:max-w-xs border border-white">
                <p className="font-bold text-slate-900 text-base md:text-lg mb-1">Island-Friendly Shipping</p>
                <p className="text-slate-600 text-xs md:text-sm">Specialized care for packages destined for the Maldives archipelago.</p>
              </div>
            </div>
          </RevealOnScroll>

          <RevealOnScroll delay={200}>
            <h2 className="text-brand-600 font-bold tracking-wide uppercase text-xs md:text-sm mb-2 md:mb-3">Why Choose Us</h2>
            <h3 className="text-2xl md:text-4xl font-extrabold text-slate-900 mb-6 md:mb-8">
              The Smartest Way to Shop Sri Lanka
            </h3>

            <div className="space-y-4 md:space-y-6">
              {WHY_CHOOSE_US_POINTS.map((point, index) => {
                const Icon = point.icon;
                return (
                  <div key={index} className="flex items-start gap-3 md:gap-4 group">
                    <div className="mt-1 bg-brand-50 p-2 rounded-lg group-hover:bg-brand-600 transition-colors duration-300 shrink-0">
                      <Icon className="w-4 h-4 md:w-5 md:h-5 text-brand-600 group-hover:text-white transition-colors" />
                    </div>
                    <div>
                      <h4 className="text-base md:text-lg font-bold text-slate-900">{point.text}</h4>
                      <p className="text-slate-500 text-xs md:text-sm mt-1">Experience premium service without the premium price tag.</p>
                    </div>
                  </div>
                )
              })}
            </div>

            <div className="mt-8 md:mt-10">
              <button onClick={() => window.location.href = "/auth/login"} className="w-full sm:w-auto bg-slate-900 hover:bg-slate-800 text-white font-bold px-8 py-3.5 rounded-xl shadow-lg transition transform hover:scale-105">
                Create Free Account
              </button>
            </div>
          </RevealOnScroll>

        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;